<template>
  <v-dialog :value="sectionEditor.show" :width="1100" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" hide-details />
        </div>

        <SectionLayout :settings="fields.settings" :container-page="fields.containerPage" />

        <div class="mb-5">
          <label class="label-input">Title Section</label>
          <div class="group-item">
            <v-checkbox v-model="fields.cardTitle.show" label="Show title block" hide-details class="mt-0 mb-2" />
            <ckeditor
              v-if="fields.cardTitle.show"
              :editor="editor"
              v-model="fields.cardTitle.content"
              :config="editorConfig"
            />
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Marquee Layout</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <label>Item Width</label>
                <v-text-field
                  v-model.number="fields.blockMarquee.itemWidth"
                  type="number"
                  suffix="px"
                  hide-details
                  class="mt-0"
                />
              </v-col>
              <v-col cols="12" md="4">
                <label>Gap Between Items</label>
                <v-text-field
                  v-model.number="fields.blockMarquee.itemGap"
                  type="number"
                  suffix="px"
                  hide-details
                  class="mt-0"
                />
              </v-col>
              <v-col cols="12" md="4">
                <label>Space Between</label>
                <v-text-field
                  v-model.number="fields.blockMarquee.spaceBetween"
                  type="number"
                  suffix="px"
                  hide-details
                  class="mt-0"
                />
              </v-col>
              <v-col cols="12" md="4">
                <label>Item Radius</label>
                <v-text-field
                  v-model.number="fields.blockMarquee.radiusItem"
                  type="number"
                  suffix="px"
                  hide-details
                  class="mt-0"
                />
              </v-col>
              <v-col cols="12" md="4">
                <label>Item Background</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.blockMarquee.backgroundItem"
                    @input="event => (fields.blockMarquee.backgroundItem = event.target.value)"
                  />
                  <v-text-field v-model="fields.blockMarquee.backgroundItem" hide-details class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <label>Speed</label>
                <v-text-field
                  v-model.number="fields.blockMarquee.speed"
                  type="number"
                  suffix="s"
                  hide-details
                  class="mt-0"
                />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-7">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Marquee Items</label>
            <v-btn small color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <div class="group-item">
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in fields.items" :key="`item-${i}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center" style="width: 100%">
                    <span>Item {{ i + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveItem(i)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="mb-4">
                    <label>Image</label>
                    <UploadImage
                      :image="{ imageSrc: item.image }"
                      :height="`160`"
                      :typeUpload="'image'"
                      @callback="obj => (item.image = obj.imageSrc)"
                      @callbackDelete="item.image = ''"
                    />
                  </div>
                  <div class="mb-4">
                    <label>Link</label>
                    <v-text-field v-model="item.link" hide-details class="mt-0" />
                  </div>
                  <div class="mb-4">
                    <v-checkbox v-model="item.rating.show" label="Show Rating" hide-details class="mt-0 mb-2" />
                    <v-rating
                      v-if="item.rating.show"
                      :value="item.rating.value"
                      @input="value => (item.rating.value = Number(value))"
                      color="warning"
                      background-color="#c1c1c1"
                      empty-icon="mdi-star-outline"
                      full-icon="mdi-star"
                      half-icon="mdi-star-half-full"
                    />
                  </div>
                  <div>
                    <v-checkbox
                      v-model="item.description.show"
                      label="Show Description"
                      hide-details
                      class="mt-0 mb-2"
                    />
                    <ckeditor
                      v-if="item.description.show"
                      :editor="editor"
                      v-model="item.description.content"
                      :config="editorConfig"
                    />
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '../common/form/upload-file/upload-image.vue';
import SectionLayout from '../common/ui-modules/section-layout/editor.vue';

const getDefaultItem = () => ({
  link: '#',
  image: '',
  rating: {
    show: true,
    value: 4,
  },
  description: {
    show: true,
    content: '<p style="text-align: center;">Lorem, ipsum dolor sit amet consectetur adipisicing elit.</p>',
  },
});

const getDefaultFields = () => ({
  title: 'Marquee Boxer Item Section',
  settings: {
    paddingTop: true,
    paddingBottom: true,
    backgroundColor: '#FFFFFF',
    textColor: '#000000',
    overlayColor: '#000000',
    overlayOpacity: 0,
    showOverlay: false,
    backgroundImage: '',
    useCustomWidth: false,
    customWidth: 1204,
  },
  containerPage: {
    enableStyle: false,
    background: '#FFFFFF',
  },
  cardTitle: {
    show: true,
    content:
      '<h2>TitanBoxers</h2><p>TitanBoxers are the best boxers on the market. They are made with the best materials and are designed to fit your body perfectly.</p>',
  },
  blockMarquee: {
    colPerView: 4,
    spaceBetween: 30,
    backgroundItem: '#3c3c3c',
    radiusItem: 10,
    speed: 10,
    itemWidth: 300,
    itemGap: 30,
  },
  items: [getDefaultItem()],
});

export default {
  name: 'MarqueeBoxerItemSectionEditor',
  components: {
    UploadImage,
    SectionLayout,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: getDefaultFields(),
    };
  },
  mounted() {
    const def = getDefaultFields();
    const extract = cloneDeep(this.sectionEditor.sectionExtract || {});
    this.fields = {
      ...def,
      ...extract,
      settings: { ...def.settings, ...(extract.settings || {}) },
      containerPage: { ...def.containerPage, ...(extract.containerPage || {}) },
      cardTitle: { ...def.cardTitle, ...(extract.cardTitle || {}) },
      blockMarquee: { ...def.blockMarquee, ...(extract.blockMarquee || {}) },
      items: extract.items && extract.items.length ? extract.items : def.items,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionMarqueeBoxerItem(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddItem() {
      this.fields.items.push(getDefaultItem());
    },
    handleRemoveItem(index) {
      if (this.fields.items.length <= 1) return;
      this.fields.items.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.group-item {
  border: 1px solid #0000000f;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.ck-editor__editable_inline,
.ck-editor__editable {
  min-height: 160px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
